// extracted by mini-css-extract-plugin
module.exports =  {"root":"juKWklIv4yuPZsu_ZaTJ"};